import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import {
  ITrackingAction,
  ITrackingObject,
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

export const DIALOG_TYPE = 'turn-on-payments';

@Component({
  selector: 'app-turn-on-payments-dialog',
  templateUrl: './turn-on-payments-dialog.component.html',
  styleUrls: ['./turn-on-payments-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TurnOnPaymentsDialogComponent implements OnInit {
  @Input() feesDescription: string;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output() onTurnOnPayments: EventEmitter<void> = new EventEmitter<void>();

  trackingObject: ITrackingObject;
  primaryActionTapped: ITrackingAction;
  secondaryActionTapped: ITrackingAction;
  dialogType: string;

  constructor(
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.dialogType = DIALOG_TYPE;
    this.trackingObject = this._trackingObjectBuilder.buildDialog(
      TrackingDialogNamesEnum.deposit_enable_payments
    );
    this.primaryActionTapped = this._trackingActionBuilder.buildButtonTapped(
      'accept_online_payments',
      this.trackingScreenName
    );
    this.secondaryActionTapped = this._trackingActionBuilder.buildButtonTapped(
      'no_thanks',
      this.trackingScreenName
    );
  }
}
